const hidePeriod = () => {
  const now = new Date();
  const hideSince = new Date(2018, 3, 14, 0, 0, 0);
  const hideUntil = new Date(2018, 3, 14, 23, 59, 59);
  return now.getTime() >= hideSince.getTime() && now.getTime() <= hideUntil.getTime();
};

export const freeBetsVisible = () => {
  const now = new Date();
  const visibleUntil = new Date(2018, 4, 29, 0, 0, 0);
  return now.getTime() < visibleUntil.getTime();
};

export const worldCupFreeBetsVisible = () => {
  const now = new Date();
  const visibleUntil = new Date(2018, 5, 14, 0, 0, 0);
  return now.getTime() < visibleUntil.getTime();
};

export default hidePeriod;
